import React, {Component} from 'react';
import {Grid, Row, Col, Form, FormGroup, ControlLabel, FormControl, ButtonToolbar} from "react-bootstrap";
import {
    TopButtonAction,
    TopButtonAdd,
    TopButtonCancel,
    TopButtonPointAction,
    TopButtonPointEdit,
    TopButtonSave
} from "../../../componentsTopsa/buttons/TopButtons";
import Validator from "../../../utilities/Validator";
import acc from 'accounting'
import moment from 'moment'
import {TopInputDate} from "../../../componentsTopsa/inputs/TopInputs";
import {TopSelect} from "../../../componentsTopsa/selects/TopSelects";
import FirmyService from "../../klienciConfig/firmy/FirmyService";
import Select from 'react-select'
import FirmyForm from "../../klienciConfig/firmy/components/FirmyForm";
import ValidatorMessages from "../../../shared/validatorMessages/ValidatorMessages";
import CurrencyInput from "../../../componentsTopsa/currencyInput/CurrencyInput";
import FakturaService from "../FakturaService";


export default class FakturaComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            current: {
                nazwa: '',
                ilosc: 1,
                cena_netto: 0,
                wartosc_netto: 0,
                vat: 23,
                kwota_vat: 0,
                wartosc_brutto: 0,
            },
            pozycje: [],
            errors: {
                nazwa: false,
                ilosc: false,
                vat: false,
            },
            data_wystawienia: moment(),
            data_sprzedazy: moment(),
            termin_zaplaty: moment(),

            waluty: [
                {value: 'PLN', label: 'PLN'}, 
                {value: 'EUR', label: 'EUR'}, 
                {value: 'USD', label: 'USD'}, 
                {value: 'GBP', label: 'GBP'}
                ],
            waluta: {value: 'PLN', label: 'PLN'},

            sposobyPlatnosci: [{value: 'GK', label: 'Gotówka'}, {value: 'PR', label: 'Przelew'}],
            sposobPlatnosci: {value: 'GK', label: 'Gotówka'},

            stawkaVat:{},
            stawkiVat:[],

            nazwaBanku: '',
            nrkonta: '',

            firmaDoFaktury: null,
            pokazFormularzDodawaniaEdycjiFirmy: false,

            czyWlaczycFormularzDodawaniaPozycji: true,

            validatorMessages: []
        };
        this.onClickZapiszFirme = this.onClickZapiszFirme.bind(this)
        this.onChangeSelectVat = this.onChangeSelectVat.bind(this)
    }


    componentDidMount() {
        this.pobierzStawkiVat()
        if (Boolean(this.props.obiektDoFaktury)) {
            this.setState({
                pozycje: this.props.obiektDoFaktury.pozycje,
                sposobPlatnosci: this.props.obiektDoFaktury.formaPlatnosci,
                czyWlaczycFormularzDodawaniaPozycji: false
            })
        }
    }

    pobierzStawkiVat(){
        FakturaService.pobierzStawkiVat().then(function (response) {
            let arr = Array.from(response.data,item=>{
                return{
                    ...item,
                    label:item.kodStVat,
                    value:parseInt(item.stawka)
                }
            })
            console.log(arr)
            this.setState({stawkiVat:arr,stawkaVat:arr.find(s=>s.value==23)})
        }.bind(this))
    }

    zmienObiektCurrent(key, value) {
        let obj = this.state.current
        obj[key] = value;
        this.setState({current: obj})
    }

    onChangeNazwa(e) {
        this.modyfikujObiektErrors('nazwa', false)
        if (e.target.value.length <= 60) {
            this.zmienObiektCurrent('nazwa', e.target.value)
        } else {
            document.getElementById('inputNazwa').value = this.state.current.nazwa
        }
    }

    onChangeIlosc(e) {
        this.modyfikujObiektErrors('ilosc', false)

        if (e.target.value === '') {
            // document.getElementById('inputIlosc').value = 1
            // this.zmienObiektCurrent('ilosc',1)
            this.obliczWartoscNetto(0)
        }
        /*
        else if(e.target.value.indexOf('e')>-1){
            document.getElementById('inputIlosc').value = 1
            this.zmienObiektCurrent('ilosc',1)
        }
        */
        else {
            if (e.target.value < 0) {
                document.getElementById('inputIlosc').value = 1
                this.zmienObiektCurrent('ilosc', 1)
                this.obliczWartoscNetto(1)
            } else {
                this.zmienObiektCurrent('ilosc', e.target.value)
                this.obliczWartoscNetto(e.target.value)
            }
        }
    }

    onChangeVat(e) {
        this.modyfikujObiektErrors('vat', false)

        let poprawne = true;
        if (e.target.value === '') {
            poprawne = false
        } else if (Validator.validateInt(e.target.value)) {
            if (!(0 <= e.target.value && e.target.value <= 100)) {
                poprawne = false
            }
        } else {
            poprawne = false
        }

        if (poprawne) {
            this.zmienObiektCurrent('vat', e.target.value);
            this.obliczKwoteVat(e.target.value)
        } else {
            this.zmienObiektCurrent('vat', 0);
            document.getElementById('inputVat').value = 0
            this.obliczKwoteVat(0)
        }

    }

    onChangeSelectVat(e){
        this.setState({stawkaVat:e})
        this.zmienObiektCurrent('vat', e.value);
        this.obliczKwoteVat(e.value)
    }

    onChangeWartoscPieniezna(e, maskedvalue, floatvalue, key) {
        this.zmienObiektCurrent(key, e)
        if (key === 'wartosc_brutto') {
            this.obliczZBruttoPola(e)
        }
        if (key === 'cena_netto') {
            this.obliczWartoscNetto(this.state.current.ilosc, e)
        }

    }

    obliczZBruttoPola(brutto) {

        let obj = this.state.current

        if (brutto === 0) {
            obj['wartosc_netto'] = 0;
            obj['cena_netto'] = 0;
            obj['kwota_vat'] = 0;
        } else {
            let vat
            if (this.state.current.vat < 10) {
                vat = parseFloat('1.0' + this.state.current.vat)
            }
            else {
                vat = parseFloat('1.' + this.state.current.vat)
            }

            let netto = (parseFloat(brutto / vat))
            let netto_szt = (parseFloat(netto / parseFloat(this.state.current.ilosc)))
            let kwota = (brutto - netto)

            obj['wartosc_netto'] = netto.toFixed(2);
            obj['cena_netto'] = netto_szt.toFixed(2);
            obj['kwota_vat'] = kwota.toFixed(2);

        }

        this.setState({current: obj})
    }

    obliczKwoteVat(vat = this.state.current.vat, netto = this.state.current.wartosc_netto) {
        let kwota = 0;
        let brutto = 0;
        if (netto > 0) {
            if (vat === 0) {
                kwota = 0;
                brutto = netto;
            } else if (0 < vat && vat <= 100) {
                kwota = ((parseFloat(netto) * parseInt(vat)) / 100)
                brutto = parseFloat(netto) + parseFloat(kwota)
            }
        }
        this.zmienObiektCurrent('kwota_vat', kwota.toFixed(2))
        this.zmienObiektCurrent('wartosc_brutto', brutto.toFixed(2))

    }

    obliczWartoscNetto(ilosc = this.state.current.ilosc, cena = this.state.current.cena_netto) {

        if (Boolean(ilosc)) {
            if (Validator.validateIntOrDouble(ilosc)) {
                if (cena >= 0) {
                    this.zmienObiektCurrent('wartosc_netto', (parseFloat(ilosc) * parseFloat(cena)).toFixed(2))
                    this.obliczKwoteVat(this.state.current.vat, (parseFloat(ilosc) * parseFloat(cena)).toFixed(2))
                }
            }
        }
    }

    onClickDodajDoTablicy() {

        let poprawne = true;

        if (!Boolean(this.state.current.nazwa)) {
            this.modyfikujObiektErrors('nazwa', true)
            poprawne = false;
        }
        if (this.state.current.ilosc <= 0) {
            this.modyfikujObiektErrors('ilosc', true)
            poprawne = false;
        }
        if (!(0 <= this.state.current.vat && this.state.current.vat <= 100)) {
            this.modyfikujObiektErrors('vat', true)
            poprawne = false;
        }

        if (poprawne) {
            let arr = this.state.pozycje
            arr.push({
                index: new Date().getTime(),
                nazwa: this.state.current.nazwa,
                ilosc: this.state.current.ilosc,
                cena_netto: parseFloat(this.state.current.cena_netto).toFixed(2),
                wartosc_netto: this.state.current.wartosc_netto,   //.toFixed(2),
                vat: this.state.current.vat,
                kwota_vat: this.state.current.kwota_vat,   //.toFixed(2),
                wartosc_brutto: parseFloat(this.state.current.wartosc_brutto).toFixed(2),

            })
            this.setState({
                pozycje: arr,
                current: {
                    nazwa: '',
                    ilosc: 1,
                    cena_netto: 0,
                    wartosc_netto: 0,
                    vat: 23,
                    kwota_vat: 0,
                    wartosc_brutto: 0,
                },
                stawkaVat:this.state.stawkiVat.find(s=>s.value==23),
                czyWlaczycFormularzDodawaniaPozycji:false
            })
            document.getElementById('inputIlosc').value = 1;
        //    document.getElementById('inputVat').value = 23;
            document.getElementById('inputNazwa').value = '';

        }

    }

    onClickUsunZPozycji(index) {
        let arr = this.state.pozycje
        arr.splice(arr.findIndex(i => i.index == index), 1);
        this.setState({pozycje: arr})
    }

    modyfikujObiektErrors(key, value) {
        let obj = this.state.errors
        obj[key] = value;
        this.setState({
            errors: obj
        })
    }

    obliczRazemBrutto() {
        if (this.state.pozycje.length === 0) {
            return 0
        } else {
            let suma = 0
            for (let i = 0; i < this.state.pozycje.length; i++) {
                suma += parseFloat(this.state.pozycje[i].wartosc_brutto)
            }
            return suma
        }
    }

    onChangeNazwaBanku(e) {
        if (e.target.value.length <= 30) {
            this.setState({nazwaBanku: e.target.value})
        } else {
            document.getElementById('inputNazwaBanku').value = this.state.nazwaBanku
        }
    }

    getCompanies(input) {
        if (!input) {
            return Promise.resolve({options: []})
        }

        return FirmyService.szukajFirmePoNipieAlboPoNazwie(input).then(function (response) {

            let arr = Array.from(response.data.content, item => {
                return {
                    ...item,
                    informacje: item.nip + ' ' + item.nazwa,
                }
            })
            return {options: arr}
        }.bind(this))
    }

    renderFirmaOption(option) {
        return (<div><span className={'label label-ebus-primary'} title={'NIP'}>{option.nip}</span> {option.nazwa}
            { option.idNabywcy?
            <span style={{color: 'grey', fontSize: '12px', marginLeft: '15px'}}><i className={'fa fa-info-circle'}></i> Tylko odbiorca!</span> : ''}
        </div>)
    }

    onClickZapiszFirme(obj, czyEdycja) {
        if (czyEdycja) {
            FirmyService.editFirma(this.state.firmaDoFaktury.idFi, obj).then(function (response) {

                let obiekt = this.state.firmaDoFaktury
                obiekt['nazwa'] = obj.nazwa
                obiekt['kodPocztowy'] = obj.kodPocztowy
                obiekt['regon'] = obj.regon
                obiekt['miejscowosc'] = obj.miejscowosc
                obiekt['nrLokalu'] = obj.nrLokalu
                obiekt['nrNieruchomosci'] = obj.nrNieruchomosci
                obiekt['ulica'] = obj.ulica
                obiekt['wojewodztwo'] = obj.wojewodztwo
                obiekt['informacje'] = obj.nip + ' ' + obj.nazwa

                this.setState({
                    firmaDoFaktury: obiekt,
                    pokazFormularzDodawaniaEdycjiFirmy: false
                })

            }.bind(this))
        }
        else {
            FirmyService.addFirma(obj).then(function (response) {
                if (response) {
                    if (response.data) {
                        this.setState({
                            firmaDoFaktury: Object.assign(response.data, {informacje: response.data.nip + ' ' + response.data.nazwa}),
                            pokazFormularzDodawaniaEdycjiFirmy: false
                        })
                    }
                }
            }.bind(this))

        }
    }

    zapiszFakture() {
        let poprawne = true
        this.state.validatorMessages = []

        if (!Boolean(this.state.firmaDoFaktury)) {
            poprawne = false
            this.dodajDoValidatorMessages('Nie wybrano firmy, na którą zostanie wystawiona faktura')
        }
        if (this.state.pozycje.length === 0) {
            poprawne = false
            this.dodajDoValidatorMessages('Nie uzupełniono ani jednej pozycji')
        }

        if (poprawne) {
            this.props.onClickZapisz(this.state)
        }
    }

    dodajDoValidatorMessages(msg) {
        let arr = this.state.validatorMessages
        arr.push(msg)
        this.setState({validatorMessages: arr})
    }

    render() {

        return (
            <div>
                <fieldset>
                    <div className={'fieldset-label'}>Wystaw nową fakturę</div>
                    <Form horizontal={true}>
                        {/*<FormGroup>
                            <Col xs={12} lg={12}>
                                <h3 style={{marginTop:0}}>
                                    Nowa faktura
                                </h3>
                            </Col>
                        </FormGroup>*/}
                        {
                            this.state.pokazFormularzDodawaniaEdycjiFirmy ?
                                <FormGroup>
                                    <Col xs={12}>
                                        <FirmyForm
                                            edytowanaFirma={this.state.firmaDoFaktury}
                                            czyMoznaEdytowacNip={!(Boolean(this.state.firmaDoFaktury))}
                                            handleClickAnuluj={() => {
                                                this.setState({pokazFormularzDodawaniaEdycjiFirmy: false})
                                            }}
                                            handleClickZapisz={this.onClickZapiszFirme}
                                        />
                                    </Col>
                                </FormGroup>
                                :
                                <FormGroup>
                                    <Col xs={12} lg={5}>
                                        <div>
                                            <ControlLabel>
                                                Firma
                                            </ControlLabel>
                                            <Select.Async value={this.state.firmaDoFaktury} onChange={(e) => {
                                                this.setState({firmaDoFaktury: e})
                                            }}
                                                          valueKey="idFi"
                                                          labelKey="informacje" loadOptions={this.getCompanies} clearable={false}
                                                          backspaceRemoves={true}
                                                          placeholder={'Wyszukaj firmę po NIP lub po nazwie'}

                                                          valueRenderer={(option) => this.renderFirmaOption(option)}
                                                          optionRenderer={(option) => this.renderFirmaOption(option)}
                                                          ignoreAccents={false}
                                                          noResultsText={<div>Brak wyników <TopButtonAdd
                                                              onClick={() => this.setState({pokazFormularzDodawaniaEdycjiFirmy: true})}
                                                              text={'Dodaj nową firmę'} buttonSize={'small'}/></div>}
                                            />
                                        </div>
                                        {
                                            Boolean(this.state.firmaDoFaktury) ?
                                                <div>
                                                    <div className={'thumbnail'} style={{padding: '15px', marginTop: '5px'}}>
                                                        <h4 style={{marginBottom: '5px'}}>Odbiorca:</h4>
                                                        <div>
                                                            <Row>
                                                                <Col xs={4}>
                                                                    <h5 style={{color: 'grey', fontStyle: 'italic'}}>Dane
                                                                        podstawowe</h5>
                                                                    <div>
                                                                        <label>Nazwa:</label> {this.state.firmaDoFaktury.nazwa}
                                                                    </div>
                                                                    <div><label>NIP:</label> {this.state.firmaDoFaktury.nip}
                                                                    </div>
                                                                    {
                                                                        Boolean(this.state.firmaDoFaktury.regon) ?
                                                                            <div>
                                                                                <label>REGON:</label> {this.state.firmaDoFaktury.regon}
                                                                            </div>
                                                                            :
                                                                            ''
                                                                    }
                                                                </Col>
                                                                <Col xs={4}>
                                                                    <h5 style={{
                                                                        color: 'grey',
                                                                        fontStyle: 'italic'
                                                                    }}>Adres</h5>
                                                                    <div>
                                                                        {Boolean(this.state.firmaDoFaktury.ulica) ? this.state.firmaDoFaktury.ulica : ''} {Boolean(this.state.firmaDoFaktury.nrNieruchomosci) ? this.state.firmaDoFaktury.nrNieruchomosci : ''}{Boolean(this.state.firmaDoFaktury.nrLokalu) ? '/' + this.state.firmaDoFaktury.nrLokalu : ''}
                                                                    </div>
                                                                    <div>
                                                                        {Boolean(this.state.firmaDoFaktury.kodPocztowy) ? this.state.firmaDoFaktury.kodPocztowy : ''} {this.state.firmaDoFaktury.miejscowosc}{Boolean(this.state.firmaDoFaktury.wojewodztwo) ? ', ' + this.state.firmaDoFaktury.wojewodztwo : ''}
                                                                    </div>
                                                                </Col>
                                                                <Col xs={4}>
                                                                    <TopButtonPointEdit
                                                                        onClick={() => this.setState({pokazFormularzDodawaniaEdycjiFirmy: true})}
                                                                        titleContent={'Edytuj dane firmy'}/>
                                                                </Col>
                                                            </Row>
                                                        </div>
                                                    </div>
                                                </div>
                                                :
                                                ''
                                        }
                                    </Col>
                                    <Col xs={12} lg={7}>
                                        <Row>
                                            <Col xs={6}>
                                                <div style={{textAlign: 'right', marginTop: '3px'}}>
                                                    <ControlLabel style={{display: 'inline-block', marginRight: '15px'}}>Data
                                                        wystawienia</ControlLabel>
                                                    <div style={{display: 'inline-block', width: '200px'}}>
                                                        <TopInputDate onChange={(e) => this.setState({data_wystawienia: e})}
                                                                      value={this.state.data_wystawienia} withoutIcon={true}/>
                                                    </div>
                                                </div>
                                                <div style={{textAlign: 'right', marginTop: '3px'}}>
                                                    <ControlLabel style={{display: 'inline-block', marginRight: '15px'}}>Data sprzedaży</ControlLabel>
                                                    <div style={{display: 'inline-block', width: '200px'}}>
                                                        <TopInputDate onChange={(e) => this.setState({data_sprzedazy: e})}
                                                                      value={this.state.data_sprzedazy}
                                                                      withoutIcon={true}/>
                                                    </div>
                                                </div>
                                                <div style={{textAlign: 'right', marginTop: '3px'}}>
                                                    <ControlLabel style={{display: 'inline-block', marginRight: '15px'}}>Termin zapłaty</ControlLabel>
                                                    <div style={{display: 'inline-block', width: '200px'}}>
                                                        <TopInputDate onChange={(e) => this.setState({termin_zaplaty: e})}
                                                                      value={this.state.termin_zaplaty}
                                                                      withoutIcon={true}/>
                                                    </div>
                                                </div>
                                            </Col>
                                            <Col xs={6}>
                                                <div style={{textAlign: 'right', marginTop: '3px'}}>
                                                    <ControlLabel
                                                        style={{display: 'inline-block', marginRight: '15px', paddingTop: 0}}>Waluta</ControlLabel>
                                                    <div style={{display: 'inline-block', width: '200px', textAlign: 'left'}}>
                                                        <TopSelect clearable={false} onChange={(e) => {
                                                            this.setState({waluta: e})
                                                        }} value={this.state.waluta} options={this.state.waluty}/>
                                                    </div>
                                                </div>
                                                <div style={{textAlign: 'right', marginTop: '3px'}}>
                                                    <ControlLabel style={{display: 'inline-block', marginRight: '15px', paddingTop: 0, top: '-5px'}}>Sposób
                                                        płatności</ControlLabel>
                                                    <div style={{display: 'inline-block', width: '200px', textAlign: 'left'}}>
                                                        <TopSelect clearable={false} onChange={(e) => {
                                                            this.setState({sposobPlatnosci: e})
                                                        }} value={this.state.sposobPlatnosci} options={this.state.sposobyPlatnosci}/>
                                                    </div>
                                                </div>
                                                {
                                                    Boolean(this.state.sposobPlatnosci.value === 'PR') ?
                                                        <div style={{textAlign: 'right', marginTop: '3px'}}>
                                                            <ControlLabel style={{display: 'inline-block', marginRight: '15px'}}>Numer
                                                                konta</ControlLabel>
                                                            <FormControl style={{display: 'inline-block', width: '200px', textAlign: 'left'}}
                                                                         id={'inputNrKonta'} type={'number'} onChange={(e) => {
                                                                this.setState({nrkonta:e.target.value})
                                                            }} />
                                                            <ControlLabel style={{display: 'inline-block', marginRight: '15px'}}>Nazwa
                                                                banku</ControlLabel>
                                                            <FormControl style={{display: 'inline-block', width: '200px', textAlign: 'left'}}
                                                                         id={'inputNazwaBanku'} onChange={(e) => {
                                                                this.onChangeNazwaBanku(e)
                                                            }} placeholder={'Max 30 znaków'}/>
                                                        </div>
                                                        :
                                                        ''
                                                }

                                            </Col>
                                        </Row>
                                    </Col>
                                </FormGroup>

                        }
                        <FormGroup>
                            <Col xs={12}>
                                <div style={{
                                    opacity: '0.7',
                                    background: '#d7ebf9',
                                    padding: '5px',
                                    margin: '5px 0',
                                    border: '1px solid transparent',
                                    borderRadius: '2px'
                                }}>
                                    <Row>
                                        <Col xs={3}>Nazwa usługi lub towaru</Col>
                                        <Col xs={1}>Ilość</Col>
                                        <Col xs={3}>
                                            <Row>
                                                <Col xs={6}>Cena netto</Col>
                                                <Col xs={6}>Wartość netto</Col>
                                            </Row>
                                        </Col>
                                        <Col xs={1}>VAT %</Col>
                                        <Col xs={3}>
                                            <Row>
                                                <Col xs={6}>Kwota VAT</Col>
                                                <Col xs={6}>Wartość brutto</Col>
                                            </Row>
                                        </Col>
                                        <Col xs={1}></Col>
                                    </Row>
                                </div>
                            </Col>
                            <Col xs={12}>
                                {
                                    this.state.pozycje.map(row => {
                                        return (
                                            <div style={{padding: '5px', margin: '5px 0', borderBottom: '1px solid #ddd', textIndent: '10px'}}>
                                                <Row>
                                                    <Col xs={3}>{row.nazwa}</Col>
                                                    <Col xs={1}>{row.ilosc}</Col>
                                                    <Col xs={3}>
                                                        <Row>
                                                            <Col xs={6}>{(row.cena_netto)}</Col>
                                                            <Col xs={6}>{(row.wartosc_netto)}</Col>
                                                        </Row>
                                                    </Col>
                                                    <Col xs={1}>{row.vat} %</Col>
                                                    <Col xs={3}>
                                                        <Row>
                                                            <Col xs={6}>{(row.kwota_vat)}</Col>
                                                            <Col xs={6}>{(row.wartosc_brutto)}</Col>
                                                        </Row>
                                                    </Col>
                                                    <Col xs={1}>
                                                        <div style={{color: 'firebrick', cursor: 'pointer', fontSize: '12px', fontWeight: 'bold'}}
                                                             onClick={() => {
                                                                 this.onClickUsunZPozycji(row.index)
                                                             }}>
                                                            <i className={'fa fa-trash'}></i> Usuń
                                                        </div>
                                                    </Col>
                                                </Row>
                                            </div>
                                        )
                                    })
                                }
                            </Col>
                            <Col xs={12}>
                                {
                                    this.state.czyWlaczycFormularzDodawaniaPozycji ?
                                        <Row>
                                            <Col xs={3}>
                                                <FormControl onChange={(e) => this.onChangeNazwa(e)} id={'inputNazwa'} placeholder={'Max 60 znaków'}
                                                             style={this.state.errors.nazwa ? {borderColor: 'red'} : {}}/>
                                            </Col>
                                            <Col xs={1}>
                                                <FormControl onChange={(e) => this.onChangeIlosc(e)} id={'inputIlosc'} type={'number'}
                                                             defaultValue={1}/>
                                            </Col>
                                            <Col xs={3}>
                                                <Row>
                                                    <Col xs={6}>
                                                        <CurrencyInput decimalSeparator="," thousandSeparator="." className="form-control"
                                                                       suffix=" zł"
                                                                       onChange={(e, maskedvalue, floatvalue) => this.onChangeWartoscPieniezna(e, maskedvalue, floatvalue, 'cena_netto')}
                                                                       value={this.state.current.cena_netto}/>
                                                    </Col>
                                                    <Col xs={6}>
                                                        <CurrencyInput decimalSeparator="," thousandSeparator="." className="form-control"
                                                                       suffix=" zł"
                                                                       onChange={(e, maskedvalue, floatvalue) => this.onChangeWartoscPieniezna(e, maskedvalue, floatvalue, 'wartosc_netto')}
                                                                       value={this.state.current.wartosc_netto} disabled={true}/>
                                                    </Col>
                                                </Row>
                                            </Col>
                                            <Col xs={1}>


                                               {/* <FormControl onChange={(e) => this.onChangeVat(e)} id={'inputVat'}
                                                             type={'number'} defaultValue={23}/>*/}

                                                <TopSelect onChange={this.onChangeSelectVat} clearable={false} value={this.state.stawkaVat} options={this.state.stawkiVat}/>
                                            </Col>
                                            <Col xs={3}>
                                                <Row>
                                                    <Col xs={6}>
                                                        <CurrencyInput decimalSeparator="," thousandSeparator="." className="form-control"
                                                                       suffix=" zł"
                                                                       onChange={(e, maskedvalue, floatvalue) => this.onChangeWartoscPieniezna(e, maskedvalue, floatvalue, 'kwota_vat')}
                                                                       value={this.state.current.kwota_vat} disabled={true}/>
                                                    </Col>
                                                    <Col xs={6}>
                                                        <CurrencyInput decimalSeparator="," thousandSeparator="." className="form-control"
                                                                       suffix=" zł"
                                                                       onChange={(e, maskedvalue, floatvalue) => this.onChangeWartoscPieniezna(e, maskedvalue, floatvalue, 'wartosc_brutto')}
                                                                       value={this.state.current.wartosc_brutto}/>
                                                    </Col>
                                                </Row>
                                            </Col>
                                            <Col xs={1}>

                                                <TopButtonPointAction buttonIcon={'fa fa-plus'} titleContent={'Dodaj wpis do pozycji'}
                                                                      buttonColor={'success'}
                                                                      onClick={() => {
                                                                          this.onClickDodajDoTablicy()
                                                                      }}/>
                                            </Col>
                                        </Row>
                                        :
                                        <Row>
                                            <Col xs={12}>
                                                <div className={'pull-right'}>
                                                    <TopButtonAction text={'Następna pozycja'} iconType={'fa fa-plus'} btnSize={'xs'}
                                                                     btnColor={'default'} elementStyle={{color:'forestgreen', marginRight:'15px'}}
                                                                     onClick={()=>this.setState({czyWlaczycFormularzDodawaniaPozycji:true})}

                                                    />
                                                </div>
                                            </Col>
                                        </Row>
                                }
                            </Col>
                            <Col xs={12}>
                                <div className={'pull-right'}>
                                    <span style={{
                                        fontWeight: 'bold',
                                        padding: '0 25px',
                                        marginTop: '25px',
                                        fontSize: '18px',
                                        display: 'inline-block'
                                    }}
                                    >Razem do zapłaty: {acc.formatMoney(this.obliczRazemBrutto())}</span>
                                </div>
                            </Col>
                        </FormGroup>
                        <FormGroup>
                            <Col xs={12}>
                                <ValidatorMessages messages={this.state.validatorMessages}/>
                            </Col>
                            <Col xs={12}>
                                <div className={'pull-right'}>
                                    <ButtonToolbar>
                                        <TopButtonCancel onClick={() => {
                                            this.props.onClickAnuluj()
                                        }}/>
                                        <TopButtonSave onClick={() => {
                                            this.zapiszFakture()
                                        }}/>
                                    </ButtonToolbar>
                                </div>
                            </Col>
                        </FormGroup>
                    </Form>
                </fieldset>
            </div>
        );
    }
}




// WEBPACK FOOTER //
// ./src/modules/fakturaModule/components/FakturaComponent.js